import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';

export const permissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const required: string | string[] = route.data['permission'];

  if (!required) return true;

  const permissions = Array.isArray(required) ? required : [required];
  const hasAccess = permissionService.hasAnyPermission(permissions);

  return hasAccess ? true : router.createUrlTree(['/app/dashboard']);
};
